import React from "react";
import ShipArea from "./ShipArea";
import EwaybillArea from "./EwaybillArea";
import WarehouseArea from "./WarehouseArea";
import { observer } from "mobx-react-lite";

interface BottomAreaProps {}

const BottomArea: React.FC<BottomAreaProps> = function (props) {
    return (
        <div className="bottom-area">
            <ShipArea />
            <EwaybillArea />

            <WarehouseArea />
        </div>
    );
};

export default observer(BottomArea);
